import { useEffect, useState } from "react";
import SwiperCore, {
  Autoplay,
  Grid,
  Navigation,
  Pagination,
  Scrollbar,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
SwiperCore.use([Navigation, Autoplay, Scrollbar, Pagination, Grid]);
import * as C from "./Customizing.styles";
import { useRouter } from "next/router";

const PortfolioSlider = ({ gallery }) => {
  const router = useRouter();
  const [portfolioSlider, setPortfolioSlider] = useState();

  const onClickMore = () => {
    router.push("/esg-guide/blog/make/");
  };

  const onClickDetail = (el) => {
    router.push(`/esg-guide/post/${el.id}/`);
  };

  return (
    <>
      <C.PortFolioSliderSection>
        <C.SliderWrapper>
          <C.SliderTitle>
            <h5>
              맞춤제작 <br />
              사례
            </h5>
            <button className="more" onClick={() => onClickMore()}>
              더 보러가기 <i className="fi-rs-angle-right" />
            </button>
            <span className="mobile">
              <h6 onClick={() => onClickMore()}>제작사례 & 포장재리뷰</h6>
              <i className="fi-rs-angle-right" onClick={() => onClickMore()} />
            </span>
          </C.SliderTitle>
          <C.Slider>
            <Swiper
              id="portfolioSwiper"
              className="portfolioSwiper"
              navigation={{
                prevEl: ".custom_prev_pf",
                nextEl: ".custom_next_pf",
              }}
              //   loop={true}
              slidesPerView={2}
              centeredSlides={false}
              breakpoints={{
                991: {
                  slidesPerView: 4,
                },
                767: {
                  slidesPerView: 3,
                },
                575: {
                  slidesPerView: 2,
                },
              }}
              scrollbar={{
                hide: false,
              }}
              initialSlide={0}
              spaceBetween={20}
              grabCursor={true}
              observer={true}
              onSwiper={setPortfolioSlider}
              onSlideChange={(swiper) =>
                setPortfolioSlider({
                  ...portfolioSlider,
                  realIndex: swiper.realIndex,
                })
              }
            >
              {gallery &&
                gallery.map((el, i) => (
                  <SwiperSlide key={i} id="portfolioSlide">
                    <C.PortfolioBox onClick={() => onClickDetail(el)}>
                      <figure>
                        <img src={el.thumbnail} />
                      </figure>
                      <span>{el.title}</span>
                    </C.PortfolioBox>
                  </SwiperSlide>
                ))}
            </Swiper>
            <C.PortfolioSliderArrows>
              <span className="custom_prev_pf">
                <i className="fi-rs-angle-small-left"></i>
              </span>
              <span className="custom_next_pf">
                <i className="fi-rs-angle-small-right"></i>
              </span>
            </C.PortfolioSliderArrows>
          </C.Slider>
        </C.SliderWrapper>
      </C.PortFolioSliderSection>
    </>
  );
};
export default PortfolioSlider;
